import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=507d1d06&scoped=true"
import script from "./authority.vue?vue&type=script&lang=js"
export * from "./authority.vue?vue&type=script&lang=js"
import style0 from "./authority.vue?vue&type=style&index=0&id=507d1d06&prod&lang=scss&scoped=true"
import style1 from "./authority.vue?vue&type=style&index=1&id=507d1d06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507d1d06",
  null
  
)

export default component.exports